var map = {
	"./1.png": 2432,
	"./10.jpg": 6726,
	"./2.png": 763,
	"./3.png": 5938,
	"./4.png": 797,
	"./5.png": 6900,
	"./7.png": 6822,
	"./8.png": 4129,
	"./9.png": 3912
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4758;